<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-alt"></i> BlockList</h3>
      </div>
    </div>
    <BlockListList ref="BlockListList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import BlockListList from './components/list/BlockListList.vue'

export default {
  name: 'BlockList',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    BlockListList
  },
  mounted () {
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.BlockListAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/blocklist/BlockList/blocklist.vue